/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }

function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

var m = require("@lexical/selection"),
    q = require("@lexical/utils"),
    r = require("lexical");

function u(c, d, h) {
  var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var e = null != a ? d.isSelected(a) : !0,
      k = r.$isElementNode(d) && d.excludeFromCopy("html");
  var f = d;
  null !== a && (f = m.$cloneWithProperties(d), f = r.$isTextNode(f) && null != a ? m.$sliceSelectedTextNodeContent(a, f) : f);

  var g = r.$isElementNode(f) ? f.getChildren() : [],
      _f$exportDOM = f.exportDOM(c),
      b = _f$exportDOM.element,
      l = _f$exportDOM.after;

  if (!b) return !1;
  var n = document.createDocumentFragment();

  for (var p = 0; p < g.length; p++) {
    var t = g[p],
        x = u(c, t, n, a);
    !e && r.$isElementNode(d) && x && d.extractWithChild(t, a, "html") && (e = !0);
  }

  e && !k ? (q.isHTMLElement(b) && b.append(n), h.append(b), l && (c = l.call(f, b)) && b.replaceWith(c)) : h.append(n);
  return e;
}

var v = new Set(["STYLE", "SCRIPT"]);

function w(c, d) {
  var _k;

  var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Map();
  var a = arguments.length > 3 ? arguments[3] : undefined;
  var e = [];
  if (v.has(c.nodeName)) return e;
  var k = null;

  var f,
      _c = c,
      g = _c.nodeName,
      b = d._htmlConversions.get(g.toLowerCase());

  g = null;

  if (void 0 !== b) {
    var _iterator = _createForOfIteratorHelper(b),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        f = _step.value;
        b = f(c), null !== b && (null === g || g.priority < b.priority) && (g = b);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  g = (f = null !== g ? g.conversion : null) ? f(c) : null;
  f = null;

  if (null !== g) {
    f = g.after;
    b = g.node;
    k = Array.isArray(b) ? b[b.length - 1] : b;

    if (null !== k) {
      var _e;

      var _iterator2 = _createForOfIteratorHelper(h),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ref = _step2.value;

          var _ref2 = _slicedToArray(_ref, 2);

          var l = _ref2[1];
          if (k = l(k, a), !k) break;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      k && (_e = e).push.apply(_e, _toConsumableArray(Array.isArray(b) ? b : [k]));
    }

    null != g.forChild && h.set(c.nodeName, g.forChild);
  }

  c = c.childNodes;
  a = [];

  for (l = 0; l < c.length; l++) {
    var _a;

    (_a = a).push.apply(_a, _toConsumableArray(w(c[l], d, new Map(h), k)));
  }

  null != f && (a = f(a));
  null == k ? e = e.concat(a) : r.$isElementNode(k) && (_k = k).append.apply(_k, _toConsumableArray(a));
  return e;
}

exports.$generateHtmlFromNodes = function (c, d) {
  if ("undefined" === typeof document || "undefined" === typeof window) throw Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
  var h = document.createElement("div"),
      a = r.$getRoot().getChildren();

  for (var e = 0; e < a.length; e++) {
    u(c, a[e], h, d);
  }

  return h.innerHTML;
};

exports.$generateNodesFromDOM = function (c, d) {
  d = d.body ? d.body.childNodes : [];
  var h = [];

  for (var e = 0; e < d.length; e++) {
    var a = d[e];
    v.has(a.nodeName) || (a = w(a, c), null !== a && (h = h.concat(a)));
  }

  return h;
};